import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { QuestionText, QuestionItem, ButtonWrapper} from './Question.style';
import { useAppStateContext } from '../../../AppState/AppState';
import { CsvReadItem } from '../../../AppState/PromotionQuestionsState/PromotionQuestionsState';
import { StatusLabel } from 'src/domains/layouts/shared/labels/StatusLabel';

interface QuestionPropsType {
    question: CsvReadItem
}

export const QuestionListItem = observer(({question}: QuestionPropsType) => {
    const { promotionQuestionsState } = useAppStateContext();
    const { setCurrentQuestion, currentQuestion, isCreateMode } = promotionQuestionsState;
    const isHighlighted = (!isCreateMode && !currentQuestion) || (!!currentQuestion && currentQuestion.id === question.id);

    if (!question) {
        return null;
    }

    return (
        <QuestionItem key={question.id} isHighlighted={isHighlighted} >
            <QuestionText>
                {question.name}
            </QuestionText>

            <ButtonWrapper>
                <StatusLabel status={question.active ? 'live' : 'ended'}>{question.active ? 'Active' : 'Inactive'}</StatusLabel>
                <Button version='secondary' size='small' onClick={() => setCurrentQuestion(question)}>Edit</Button>
            </ButtonWrapper>
        </QuestionItem>
    );

});
